module.exports = __webpack_public_path__ + "static/media/no_party.3ce3858e.svg";